<div class="dialog">
  <div class="flex-row space-between-center">
    <div>{{ 'BULK_UPDATE_FORM.TITLE' | translate }}</div>
    <span class="ui-icon-close c-p" mat-dialog-close></span>
  </div>
  <div
    [formGroup]="form"
    class="dialog-content flex-col start-start gap-16 p-24"
  >
    <div *ifDeveloper class="section">
      {{ 'BULK_UPDATE_FORM.DETAILS' | translate }}
    </div>
    <div *ifDeveloper class="flex-row start-start gap-16 flex-wrap">
      <div class="flex-col start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.CONTROL' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.CONTROL_MODE' | translate
          "
          class="ui-selector"
          formControlName="disabled"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
      <div class="flex-col start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.ANALYTIC_MODE.LABEL' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ANALYTIC_MODE' | translate
          "
          class="ui-selector"
          formControlName="analyticMode"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="AnalyticModes.Enabled"
            >{{ analyticModesStr[AnalyticModes.Enabled] | translate }}
          </mat-option>
          <mat-option [value]="AnalyticModes.ThumbnailsOnly"
            >{{ analyticModesStr[AnalyticModes.ThumbnailsOnly] | translate }}
          </mat-option>
          <mat-option [value]="AnalyticModes.Disabled"
            >{{ analyticModesStr[AnalyticModes.Disabled] | translate }}
          </mat-option>
        </mat-select>
      </div>
      <div class="flex-col start-start gap-8">
        <div>
          {{ 'BULK_UPDATE_FORM.ANALYTIC_TRAINING_MODE.LABEL' | translate }}
        </div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ANALYTIC_TRAINING_MODE' | translate
          "
          class="ui-selector"
          formControlName="trainingMode"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="AnalyticTrainingMode.Customized"
            >{{ trainingModeStr[AnalyticTrainingMode.Customized] | translate }}
          </mat-option>
          <mat-option [value]="AnalyticTrainingMode.Static"
            >{{ trainingModeStr[AnalyticTrainingMode.Static] | translate }}
          </mat-option>
          <mat-option [value]="AnalyticTrainingMode.Locked"
            >{{ trainingModeStr[AnalyticTrainingMode.Locked] | translate }}
          </mat-option>
        </mat-select>
      </div>
      <div class="flex-col start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.SD_CARD' | translate }}</div>
        <mat-select
          [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.SD_CARD' | translate"
          class="flex-row ui-selector"
          formControlName="sdCardEnabled"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
    </div>
    <div *ifDeveloper class="flex-col start-start gap-8">
      <div>{{ 'BULK_UPDATE_FORM.CAMERA_LOCATION' | translate }}</div>
      <div>{{ 'BULK_UPDATE_FORM.WIP' | translate }}</div>
    </div>
    <div *ifDeveloper class="vertical-divider">&nbsp;</div>
    <!-- Credentials -->
    <div *ifDeveloper class="section">
      {{ 'BULK_UPDATE_FORM.CREDENTIALS' | translate }}
    </div>
    <div *ifDeveloper class="flex-row start-start gap-16">
      <div class="flex-col start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.USERNAME' | translate }}</div>
        <input
          [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.USERNAME' | translate"
          class="ui-input"
          formControlName="username"
        />
      </div>
      <div class="flex-col start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.PASSWORD' | translate }}</div>
        <input
          [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.PASSWORD' | translate"
          class="ui-input"
          formControlName="password"
        />
      </div>
    </div>
    <div class="vertical-divider">&nbsp;</div>
    <!-- Streams -->
    <div class="section">{{ 'BULK_UPDATE_FORM.STREAMS' | translate }}</div>
    <div class="flex-col start-start gap-8">
      <div class="flex-row start-start gap-24">
        <div class="flex-col start-start gap-8">
          <div>
            <div class="stream-label">
              {{ 'BULK_UPDATE_FORM.MAIN_STREAM' | translate }}
            </div>
          </div>
          <div class="flex-row center-center" style="height: 34px">&nbsp;</div>
        </div>
        <div class="flex-row start-start gap-16">
          <div class="flex-col start-start gap-8">
            <div>{{ 'BULK_UPDATE_FORM.PORT' | translate }}</div>
            <input
              [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.PORT' | translate"
              class="ui-input"
              formControlName="mainStreamPort"
            />
          </div>
          <div class="flex-col start-start gap-8">
            <div>{{ 'BULK_UPDATE_FORM.RTSP' | translate }}</div>
            <input
              [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.RTSP' | translate"
              class="ui-input"
              formControlName="mainStreamRtsp"
            />
          </div>
          <div class="flex-col start-start gap-8">
            <div>{{ 'BULK_UPDATE_FORM.TCP' | translate }}</div>
            <mat-select
              [placeholder]="
                'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
              "
              class="flex-row ui-selector"
              formControlName="forceTcp"
            >
              <mat-option [value]="null">{{
                'COMMON.NONE' | translate
              }}</mat-option>
              <mat-option [value]="true">{{
                'COMMON.ENABLED' | translate
              }}</mat-option>
              <mat-option [value]="false">{{
                'COMMON.DISABLED' | translate
              }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-col start-start gap-8">
      <div class="flex-row start-start gap-24">
        <div class="flex-col start-start gap-8">
          <div>
            <div class="stream-label">
              {{ 'BULK_UPDATE_FORM.SUB_STREAM' | translate }}
            </div>
          </div>
          <div class="flex-row center-center" style="height: 34px">&nbsp;</div>
        </div>
        <div class="flex-row start-start gap-16">
          <div class="flex-col start-start gap-8 sub-enable">
            <div>{{ 'BULK_UPDATE_FORM.CONTROL' | translate }}</div>
            <mat-select
              [placeholder]="
                'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
              "
              class="flex-row ui-selector"
              formControlName="subStreamEnabled"
            >
              <mat-option [value]="null">{{
                'COMMON.NONE' | translate
              }}</mat-option>
              <mat-option [value]="true">{{
                'COMMON.ENABLED' | translate
              }}</mat-option>
              <mat-option [value]="false">{{
                'COMMON.DISABLED' | translate
              }}</mat-option>
            </mat-select>
          </div>
          <div class="flex-col start-start gap-8">
            <div>{{ 'BULK_UPDATE_FORM.PORT' | translate }}</div>
            <input
              [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.PORT' | translate"
              class="ui-input"
              formControlName="subStreamPort"
            />
          </div>
          <div class="flex-col start-start gap-8">
            <div>{{ 'BULK_UPDATE_FORM.RTSP' | translate }}</div>
            <input
              [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.RTSP' | translate"
              class="ui-input"
              formControlName="subStreamRtsp"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-divider">&nbsp;</div>
    <!-- Storage -->
    <div class="section">{{ 'BULK_UPDATE_FORM.STORAGE' | translate }}</div>
    <app-camera-storage-settings-tab
      #storageSettings
      (onStorageSettingsChange)="storageChanged()"
      [standalone]="true"
      [style.height.px]="storageSettings.wrapperHeight"
    ></app-camera-storage-settings-tab>
    <div class="vertical-divider">&nbsp;</div>
    <!-- Live View -->
    <div class="section">{{ 'CAMERA_EDIT_MENU.LIVE_VIEW' | translate }}</div>
    <live-view-tab
      #liveViewSettings
      (onLiveViewChange)="liveViewChanged()"
      [standalone]="true"
    ></live-view-tab>
    <div class="vertical-divider">&nbsp;</div>
    <!-- Configuration -->
    <div class="section">
      {{ 'BULK_UPDATE_FORM.CONFIGURATION' | translate }}
    </div>
    <app-configuration-tab
      #configurationSettings
      (onConfigurationChange)="configurationChanged()"
      [standalone]="true"
    ></app-configuration-tab>
    <div class="vertical-divider">&nbsp;</div>
    <div class="section">{{ 'BULK_UPDATE_FORM.ANALYTIC' | translate }}</div>
    <div class="flex-row start-start gap-16 w-100">
      <div class="flex-col flex start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.PROTECTIVE_GEAR' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
          "
          class="flex-row ui-selector"
          formControlName="protectiveGear"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
      <div class="flex-col flex start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.FORKLIFT' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
          "
          class="flex-row ui-selector"
          formControlName="forklift"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
      <div class="flex-col flex start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.SHOPPING_CART' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
          "
          class="flex-row ui-selector"
          formControlName="shoppingCart"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
      <div class="flex-col flex start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.CONTAINER' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
          "
          class="flex-row ui-selector"
          formControlName="container"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="flex-row start-start gap-16">
      <div *ifDeveloper class="flex-col start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.FPS' | translate }}</div>
        <mat-select
          [placeholder]="'BULK_UPDATE_FORM.PLACEHOLDERS.FPS' | translate"
          class="flex-row ui-selector"
          formControlName="fps"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="4">4</mat-option>
          <mat-option [value]="5">5</mat-option>
          <mat-option [value]="6">6</mat-option>
          <mat-option [value]="7">7</mat-option>
          <mat-option [value]="8">8</mat-option>
          <mat-option [value]="9">9</mat-option>
          <mat-option [value]="10">10</mat-option>
          <mat-option [value]="11">11</mat-option>
          <mat-option [value]="12">12</mat-option>
          <mat-option [value]="13">13</mat-option>
          <mat-option [value]="14">14</mat-option>
          <mat-option [value]="15">15</mat-option>
        </mat-select>
      </div>
      <div class="flex-col flex start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.ZONE_DWELL' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
          "
          class="flex-row ui-selector"
          formControlName="zoneDwell"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
      <div class="flex-col flex start-start gap-8">
        <div>{{ 'BULK_UPDATE_FORM.ADVANCED_FALL_DETECTION' | translate }}</div>
        <mat-select
          [placeholder]="
            'BULK_UPDATE_FORM.PLACEHOLDERS.ENABLE_DISABLE' | translate
          "
          class="flex-row ui-selector"
          formControlName="advancedFallDetection"
        >
          <mat-option [value]="null">{{
            'COMMON.NONE' | translate
          }}</mat-option>
          <mat-option [value]="true">{{
            'COMMON.ENABLED' | translate
          }}</mat-option>
          <mat-option [value]="false">{{
            'COMMON.DISABLED' | translate
          }}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="vertical-divider">&nbsp;</div>
    <!-- Tags -->
    <div class="section">{{ 'BULK_UPDATE_FORM.TAGS' | translate }}</div>
    <div class="w-100 tags-select">
      <app-tag-select formControlName="tags"></app-tag-select>
    </div>
    <div class="vertical-divider"></div>
  </div>
  <div class="actions flex-row space-between-center gap-8">
    <div>
      <div *ngIf="numberOfFieldsToUpdate">
        {{
          'BULK_UPDATE_FORM.UPDATED_FIELDS_DESCRIPTION'
            | translate
              : {
                  count: numberOfFieldsToUpdate,
                  field:
                    numberOfFieldsToUpdate > 1
                      ? ('BULK_UPDATE_FORM.FIELDS' | translate)
                      : ('BULK_UPDATE_FORM.FIELD' | translate),
                  cameraNum: Object.keys(data.camerasToManage ?? {}).length,
                }
        }}
      </div>
    </div>
    <div class="flex-row gap-8">
      <ui-button (clickAction)="close()" type="default">
        {{ 'COMMON.DISCARD' | translate }}
      </ui-button>
      <ui-button
        (clickAction)="save()"
        [disabled]="!numberOfFieldsToUpdate"
        [loading]="loading"
        type="primary"
        >{{ 'COMMON.SAVE' | translate }}
      </ui-button>
    </div>
  </div>
</div>
